import ZonePanelContainer from 'scripts/defa/zones/view-zone-panel-container';
import Zones              from 'scripts/defa/zones/collection-zones';
import ZoneCollectionView from 'scripts/defa/zones/view-zone-collection-view';
import ControlModule      from 'scripts/poppet/control-module';
import template           from 'templates/controlZones.jst.html';

/**
 * defa.views.ControlZonesView
 * A control module for unit zones.
 * @version 1.3.0
 */

const selectors = {
	regionSticky   : '[data-region=zones-sticky]',
	regionContainer: '[data-region=zones-container]',
	regionInactiveZones: '[data-region=zones-inactive]',
	toggleButton   : '[data-toggle=expand-spoiler]',
	toggleSpoiler  : '[data-container=expand-spoiler]',
};

let channelNav = Bb.Radio.channel( 'nav' );

const ControlZonesView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:zones',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-zones' );
	},
	
	ui: {
		toggle  : selectors.toggleButton,
		spoiler : selectors.toggleSpoiler,
	},
	
	events: {
		'click @ui.toggle': 'onClickToggle',
	},

	
	regions: {
		sticky   : selectors.regionSticky,
		container: selectors.regionContainer,
		inactiveZones : selectors.regionInactiveZones,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	onClickToggle: function( event ) {
		
		event.preventDefault();
		this.options.subId = undefined;
		// Note: happens after the behavior trigger, so the "open" class has just been added or removed.
		if (  this.ui.toggle.hasClass( 'open' ) ) {
			this._showAllZones();
		}else{
			this._showZones();
		}
		
		ControlModule.prototype.onClickToggle.call( this, event );
	},
	
	onRender: function () {
		if ( this.model.get('zones').length > 0 ) {

			if(this._isOpen() || this.ui.toggle.hasClass( 'open' )){
				// show a single zone
				if ( this.options.subId ) {
					this._showSingleZone( this.options.subId );
					// show all the zones
				}else{
					this._showAllZones()
				}
			}
			else {
				this._showZones();
			}
		}
	},
	
	afterModelComplete: function () {
		if ( this.ui.toggle.hasClass( 'open' )) {
			if ( this.options.subId ) {
				this._showSingleZone( this.options.subId );
				// show all the zones
			}
			else{
				this._showAllZones();
			}
		}else{
			this._showZones()
		}
	},
	
	onChildviewNav: function( event, params ) {
		let zoneId;
		switch( event ) {
			
			case 'unit:control:zones' :
				this._showZones();
				this.options.subId = undefined;
				break;
				
			case 'unit:control:zone' :
				zoneId = params[1];
				this.expandOpen();
				this._showSingleZone( zoneId );
				this.options.subId = zoneId;
				break;
		}
		
		channelNav.trigger( event, params, {} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	// //TODO! Make each zone have its own loading state
	// _isModelComplete: function () {
	// 	console.log('overriding default isComplete')
	// },
	
	_isModelComplete: function () {
		//Check if model is complete
		if ( _.isFunction( this.model._areAllModelsComplete) ) {
			if ( !this.model._areAllModelsComplete() ) {
				this.busy();
				this.$( '.radio-strip-wrap' ).addClass( 'faded' );
			}
			this.stopListening(this.model, 'change');
			this.listenTo( this.model, 'change', function ( model ) {
				if ( model._areAllModelsComplete() && this.isBusy() ) {
					this.idle();
					this.$( '.radio-strip-wrap' ).removeClass( 'faded' );
					this.afterModelComplete();
				} else if ( !model._areAllModelsComplete() && !this.isBusy() ) {
					this.busy();
					this.$( '.radio-strip-wrap' ).addClass( 'faded' );
				}
			} );
		}
	},
	
	/**
	 * Shows a single zone, with options to edit the zones information
	 * @private
	 * !TODO send in view as a param and use this to show manual when adding the manual button to the zone view
	 * @void
	 */
	_showSingleZone: function( zoneId ) {
		// emptyRegions
		this.getRegion( 'container' ).empty();
		this.getRegion( 'sticky' ).empty();
		this.getRegion( 'inactiveZones' ).empty();
		
		let zonePanelContainer = new ZonePanelContainer( _.extend( this.options, {
			view      : 'menu',
			closeLink : false,
			model     : this.model.getZone(zoneId),
		}));
		
		this.showChildView( 'container', zonePanelContainer, false );
	},
	
	/**
	 * Shows all active zones of this unit.
	 * @private
	 * @void
	 */
	_showZones: function() {
		// emptyRegions
		this.getRegion( 'container' ).empty();
		this.getRegion( 'sticky' ).empty();
		this.getRegion( 'inactiveZones' ).empty();
		
		let zoneCollection = new Zones(this.model.get('zones').filter(function(zone) {
			let mode = zone.getModel( '5' ).get( 'zoneMode' );
			return mode != 'disabled'
		}));
		
		let zoneView = new ZoneCollectionView( {
			collection     : zoneCollection,
			settingsHome   : this.options.settingsHome
		} );
	
		this.showChildView( 'sticky', zoneView);

	},
	
	/**
	 * Shows all zones of this unit.
	 * @private
	 * @void
	 */
	_showAllZones: function(){
		this.getRegion( 'container' ).empty();
		this.getRegion( 'sticky' ).empty();
		this.getRegion( 'inactiveZones' ).empty();
		
		let zoneCollection = new Zones(this.model.get('zones').filter(function(zone) {
			return zone !== null;
		}));
		let zoneView = new ZoneCollectionView( {
			collection     : zoneCollection,
			settingsHome   : this.options.settingsHome
		} );
		
		this.showChildView('inactiveZones', zoneView);
	},
} );

export default ControlZonesView;
